import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";
import { SelfDescribingEvent } from "../vendors/snowplow/context-api";
import { AddToCartContext, CartContext, UserContext, Events } from "../types";
import { submitSPEvents } from "./emitSnowplowEvent";

export type AddToCartEvent = {
  sourceId?: string | number;
  sourceType?: number;
  sourcePosition?: number;
  eventId: number;
  offerId: number;
  sellerId: number;
  productId: number;
  // The tracking ID added by the sajari-search service
  srtrev: string | undefined;
  snowplowContexts: SelfDescribingEvent[];
};

export function emitAddToCartLegacy(event: AddToCartEvent) {
  event.snowplowContexts.forEach((snowplowEvent) =>
    trackSelfDescribingEvent({ event: snowplowEvent })
  );
}

export function emitAddToCart({
  success,
  source_id,
  source_type,
  source_position,
  offer_id,
  position,
  event_id,
  trigger,
  customer_id,
  srtrev,
}: AddToCartContext["options"]) {
  submitSPEvents<CartContext | UserContext | AddToCartContext>([
    {
      context: Events.ADD_TO_CART,
      options: {
        success,
        source_id,
        source_type,
        source_position,
        offer_id,
        position,
        event_id,
        trigger,
        customer_id,
        srtrev,
      },
    },
    { context: Events.USER },
    { context: Events.CART },
  ]);
}
